/* eslint-disable */
/// This file is auto generated - do not edit manually
export const MostLiked = 'Website.ProductReview.Sort.MostLiked';
export const LatestReviewed = 'Website.ProductReview.Sort.LatestReviewed';
export const EarliestReviewed = 'Website.ProductReview.Sort.EarliestReviewed';
export const HighestRating = 'Website.ProductReview.Sort.HighestRating';
export const LowestRating = 'Website.ProductReview.Sort.LowestRating';
